
































































































































































import { Component, Vue } from 'vue-property-decorator';
import Footer from '../common/Footer.vue';
import MapLogList from '../parts/MapLogList.vue';
import MapLogLine from '../parts/MapLogLine.vue';
import RealDateTime from '../parts/RealDateTime.vue';
import MiniCharacterList from '@/components/parts/MiniCharacterList.vue';
import NotificationService from '@/services/notificationservice';
import CharacterIcon from '@/components/parts/CharacterIcon.vue';
import RuleSetLabel from '@/components/parts/RuleSetLabel.vue';
import Map from '@/components/parts/Map.vue';
import EntryPage from '@/components/pages/EntryPage.vue';
import AsyncUtil from '../../models/common/AsyncUtil';
import ArrayUtil from '../../models/common/arrayutil';
import Streaming from './../../api/streaming';
import ApiStreaming from './../../api/apistreaming';
import * as api from './../../api/api';
import * as def from '@/common/definitions';
import * as current from '@/common/current';
import OnlineModel from '@/models/status/onlinemodel';
import Enumerable from 'linq';

@Component({
  components: {
    MapLogList,
    MapLogLine,
    RealDateTime,
    MiniCharacterList,
    Map,
    CharacterIcon,
    EntryPage,
    Footer,
    RuleSetLabel,
  },
})
export default class TopPage extends Vue {
  private mlogs: api.MapLog[] = [];
  private m2logs: api.MapLog[] = [];
  private updateLogs: api.CharacterUpdateLog[] = [];

  private system: api.SystemData = new api.SystemData();
  private countries: api.Country[] = [];
  private countryMessages: api.CountryMessage[] = [];
  private towns: api.Town[] = [];
  private nextMonthSeconds = 0;
  private nextMonthTimerDate: Date = new Date();
  private isLoadingSystem = true;
  private onlines = new OnlineModel();

  private isLoadingCurrentCharacter = true;
  private currentCharacter = new api.Character();

  private nextMonthSecondsTimer = 0;
  private selectedTab = 0;
  private lastMapLogId = Number.MAX_VALUE;
  private isNoMoreMapLogs = false;
  private isLoadingMoreMapLogs = false;
  private isImportantMapLogs = false;
  private isApp = false;

  public get topMlogs(): api.MapLog[] {
    return Enumerable.from(this.mlogs).take(5).toArray();
  }

  public get topM2logs(): api.MapLog[] {
    return Enumerable.from(this.m2logs).take(5).toArray();
  }

  public get isUsingMSIE(): boolean {
    const userAgent = window.navigator.userAgent.toLowerCase();
    return userAgent.indexOf('msie') >= 0 || userAgent.indexOf('trident') >= 0 || userAgent.indexOf('edge') >= 0;
  }

  public login() {
    this.$router.push('login');
  }

  public goStatus() {
    this.$router.push('status');
  }

  public entry() {
    if (this.selectedTab !== 1) {
      this.selectedTab = 1;
    } else if (this.selectedTab === 1) {
      this.selectedTab = 0;
    }
  }

  private created() {
    if (this.$route.query.app) {
      (window as any).sangokukmy_app = this.$route.query.app;
      this.isApp = true;
    }

    // 次の月までの秒数を進めるタイマーを開始
    if (this.nextMonthSecondsTimer > 0) {
      clearInterval(this.nextMonthSecondsTimer);
    }
    this.nextMonthSecondsTimer = setInterval(() =>
      this.nextMonthSeconds = Math.floor((this.nextMonthTimerDate.getTime() - new Date().getTime()) / 1000),
      1000);

    // ログイン中の武将をロード
    const tokenLimit = new Date();
    tokenLimit.setHours(tokenLimit.getHours() + 24);
    if (current.tokenExpirationTime > tokenLimit) {
      api.Api.getMyCharacter()
        .then((c) => {
          this.currentCharacter = c;
          (window as any).sangokukmy_charaId = c.id;
        })
        .finally(() => {
          this.isLoadingCurrentCharacter = false;
        });
    } else {
      this.isLoadingCurrentCharacter = false;
    }

    // ストリーミングを開始
    ApiStreaming.top.clearEvents();
    ApiStreaming.top.on<api.SystemData>(api.SystemData.typeId, (log) => {
      this.system = log;

      const systemMonthDate = api.DateTime.toDate(log.currentMonthStartDateTime);
      systemMonthDate.setSeconds(systemMonthDate.getSeconds() + def.UPDATE_TIME);
      this.nextMonthTimerDate = new Date();
      this.nextMonthTimerDate.setTime(
        this.nextMonthTimerDate.getTime() + Math.floor(systemMonthDate.getTime() - new Date().getTime()));

      this.isLoadingSystem = false;
    });
    ApiStreaming.top.on<api.Country>(api.Country.typeId, (log) => {
      ArrayUtil.addItem(this.countries, log);
    });
    ApiStreaming.top.on<api.CountryMessage>(api.CountryMessage.typeId, (log) => {
      if (log.type === api.CountryMessage.typeSolicitation) {
        ArrayUtil.addItemUniquely(this.countryMessages, log, (cm) => cm.countryId);
      }
    });
    ApiStreaming.top.on<api.Town>(api.Town.typeId, (log) => {
      if (log.type === api.Town.typeRemoved) {
        this.towns = this.towns.filter((t) => t.id !== log.id);
      } else {
        ArrayUtil.addItem(this.towns, log);
      }
    });
    ApiStreaming.top.on<api.MapLog>(api.MapLog.typeId, (log) => {
      this.onMapLogReceived(log);
    });
    ApiStreaming.top.on<api.CharacterUpdateLog>(api.CharacterUpdateLog.typeId, (log) => {
      ArrayUtil.addLog(this.updateLogs, log, 5);
    });
    ApiStreaming.top.on<api.ApiSignal>(api.ApiSignal.typeId, (signal) => {
      if (signal.type === 7) {
        // リセットされた
        location.reload();
      }
    });
    ApiStreaming.top.on<api.CharacterOnline>(
      api.CharacterOnline.typeId,
      (obj) => this.onlines.onOnlineDataReceived(obj));
    ApiStreaming.top.start();

    ApiStreaming.top.onBeforeReconnect = () => {
      this.onlines.reset();
    };
    window.onscroll = (ev: any) => this.onPageScrolled(ev);
  }

  private destroyed() {
    ApiStreaming.top.stop();
  }

  private onMapLogReceived(log: api.MapLog, isLast: boolean = false) {
    if (!isLast) {
      ArrayUtil.addLog(this.mlogs, log);
      if (log.isImportant) {
        ArrayUtil.addLog(this.m2logs, log);
      }
    } else {
      ArrayUtil.addItem(this.mlogs, log);
      if (log.isImportant) {
        ArrayUtil.addItem(this.m2logs, log);
      }
    }
    if (log.id < this.lastMapLogId && (!log.isImportant || log.eventType === 14)) {
      this.lastMapLogId = log.id;
    }
  }

  private onPageScrolled(event: any) {
    if (this.isScrolled(event)) {
      if (this.selectedTab === 2) {
        // 地図
        if (!this.isNoMoreMapLogs) {
          this.isLoadingMoreMapLogs = true;
          api.Api.getMapLog(this.lastMapLogId, 300)
            .then((logs) => {
              if (logs.length > 0) {
                Enumerable.from(logs).reverse().forEach((l) => {
                  this.onMapLogReceived(l, true);
                  this.lastMapLogId = l.id;
                });
                this.mlogs = Enumerable
                  .from(this.mlogs)
                  .orderByDescending((m) => api.DateTime.toDate(m.date))
                  .toArray();
              } else {
                this.isNoMoreMapLogs = true;
              }
            })
            .catch(() => {
              NotificationService.loadMapLogFailed.notify();
            })
            .finally(() => {
              this.isLoadingMoreMapLogs = false;
            });
        }
      }
    }
  }

  private isScrolled(event: any): boolean {
    // スクロールの現在位置 + 親（.item-container）の高さ >= スクロール内のコンテンツの高さ
    return (window.pageYOffset + 250 + window.innerHeight) >= document.body.scrollHeight;
  }

  private reloadPage() {
    window.location.href = '/?app=ios';
  }
}
